<template>
  <div class="flex items-center h-screen">
    <div class="flex-1 w-full text-center px-4 py-2 m-2">
      <div class="w-4/5 ml-auto mr-auto">
        <h1>{{ getText('intro_title') }}</h1>
        <div v-html="getText('intro_text')" class="text">{{ getText('intro_text') }}</div>
      </div>
      <div class="ml-auto mr-auto mt-20 text-center">
        <router-link :to="{ name: 'headset', params: { lang: $route.params.lang }}">
          <button
            class="bg-white text-black font-bold py-3 px-10 rounded-full"
          >{{ getText('button_alles_klar') }}</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
}

.text {
  font-family: FoundryWilsonNormal;
  font-size: 32px;
  margin-top: 20px;
  line-height: 35px;
  letter-spacing: 2px !important;
}
</style>

<script>
export default {
  name: "Intro",
  methods: {
    getText: function(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    }
  }
};
</script>

